import { getCurrentTime } from "../auth/data/tools";
import { User } from "../interfaces/User.interface";

export const validateToken = async(userInfo: User, setUserInfo:(user: User) => void, login: (infoToken: User, reload: boolean, redirect: boolean) => User):Promise<User> => {
    const requestTime = getCurrentTime();

    if ((userInfo.loggedIn + userInfo.expires) <= requestTime) {
        const newUser = await login(userInfo, true, false);
        setUserInfo(newUser);
        return newUser;
    }

    return userInfo;
}